(function() {
  'use strict';

  angular.module('app').controller('TariffController', TariffController);

  TariffController.$inject = [
    '$rootScope', '$scope', '$location', '$timeout', '$translate', '$filter', '$routeParams',
    '$uibModal', 'blockUI', '$uibModalStack',
    'NotifyService', 'BusinessService', 'SelectService'];

  function TariffController($rootScope, $scope, $location, $timeout, $translate, $filter, $routeParams,
      $uibModal, blockUI, $uibModalStack,
      NotifyService, BusinessService, SelectService) {

    $scope.bool_options = [
      'mobile_app_publishing',
      'mobile_app_main_page_news',
      'promotional_bonuses_support',
      'integration_with_pos',
      'special_accounts_processing',
      'ulg_targeting_support',
      'mobile_app_payment'
    ];
    $scope.num_options = [
      'min_day_account_price',
      'month_account_price',
      'free_active_pos_count',
      'month_active_pos_price',
      'free_active_terminals_count',
      'month_active_terminal_price',
      'redeemed_discount_percentage',
      'amount_to_pay_percentage',
      'special_account_redeem_percentage',
      'free_transactions_count',
      'transaction_price',
      'free_customers_count',
      'new_customer_price',
      'free_sms_count',
      'sms_tariff_plan_id',
      'free_viber_count',
      'viber_tariff_plan_id',
      'free_push_count',
      'push_price',
      'free_incust_chatbot_count',
      'incust_chatbot_price',
      'free_email_count',
      'email_price',
      'ulg_sms_price',
      'ulg_push_price'
    ];
    $scope.detail_options = [
      'pos_count',
      'terminals_count',
      'redeem_discount_amount',
      'to_pay_amount',
      'special_account_redeem_amount',
      'transactions_count',
      'transactions_count_left',
      'transactions_count_over',
      'new_customer_count',
      'new_customer_count_left',
      'new_customer_count_over',
      'sms_count',
      'sms_count_left',
      'sms_count_over',
      'viber_count',
      'viber_count_left',
      'viber_count_over',
      'push_count',
      'push_count_left',
      'push_count_over',
      'incust_chatbot_count',
      'incust_chatbot_count_left',
      'incust_chatbot_count_over',
      'email_count',
      'email_count_left',
      'email_count_over',
      'ulg_sms_count',
      'ulg_push_count',
      'pkpass_messages_count',
      'pkpass_messages_count_left',
      'pkpass_messages_count_over',
      'evs_phone_requests_count',
      'evs_phone_requests_count_left',
      'evs_phone_requests_count_over'
    ];

    $scope.data = {
      tariff_details_filters: [
        {id: 'show_all', title: 'show_all'},
        {id: 'refill', title: 'refill'},
        {id: 'refill-cancel', title: 'refill-cancel'},
        {id: 'refill-credit', title: 'refill-credit'},
        {id: 'refill-credit-cancel', title: 'refill-credit-cancel'},
        {id: 'discount', title: 'discount'},
        {id: 'additional-service', title: 'additional_services_amount'},
        {id: 'business-bonuses-redeemed', title: 'business-bonuses-redeemed'},
        {id: 'account', title: 'account_payment_amount'},
        {id: 'min-day-delta', title: 'min_day_delta_amount'},
        {id: 'pos', title: 'active_pos_payment_amount'},
        {id: 'terminals', title: 'active_terminals_payment_amount'},
        {id: 'redeem-discount', title: 'redeemed_discount_payment_amount'},
        {id: 'amount-to-pay', title: 'amount_to_pay_payment_amount'},
        {id: 'transaction', title: 'transactions_payment_amount'},
        {id: 'new-customer', title: 'new_customers_payment_amount'},
        {id: 'sms', title: 'sms_payment_amount'},
        {id: 'viber', title: 'viber_payment_amount'},
        {id: 'push', title: 'push_payment_amount'},
        {id: 'incust-chatbot', title: 'incust_chatbot_payment_amount'},
        {id: 'evs-phone', title: 'evs_phone_requests_payment_amount'},
        {id: 'external-verification-service-phone', title: 'external_verification_service_phone'},
        {id: 'pkpass-message', title: 'pkpass-message'},
        {id: 'email', title: 'email_payment_amount'},
        {id: 'special-account-redeem', title: 'special_account_redeem_payment_amount'},
        {id: 'ulg-push', title: 'ulg_push_amount'},
        {id: 'ulg-sms', title: 'ulg_sms_amount'},
        {id: 'feedback-source', title: 'feedback-source'}
      ],
      tariff_details_options: [
        'min_day_delta_amount',
        'account_payment_amount',
        'active_pos_payment_amount',
        'active_terminals_payment_amount',
        'redeemed_discount_payment_amount',
        'amount_to_pay_payment_amount',
        'transactions_payment_amount',
        'new_customers_payment_amount',
        'sms_payment_amount',
        'viber_payment_amount',
        'push_payment_amount',
        'incust_chatbot_payment_amount',
        'email_payment_amount',
        'pkpass_messages_payment_amount',
        'evs_phone_requests_payment_amount',
        'special_account_redeem_payment_amount',
        'ulg_push_amount',
        'ulg_sms_amount',
        'additional_services_amount',
        'ex_coupon_redeem_fee_payouts_amount',
        'ex_coupon_redeem_fee_receipts_amount',
        'ex_coupon_redeem_fee_payment_amount'
      ]
    };

    $scope.isPageMode = isPageMode;
    $scope.staff = {
      pager: {
        page: 1,
        count: $rootScope.ENV.PAGER_COUNT || 10
      }
    };
    $scope.pager_count = [10, 20, 50, 100];

    $scope.model = {};

    $scope.inlineMessage = '';

    $scope.popupBonusesRedeem = popupBonusesRedeem;
    $scope.getLocalizedPath = getLocalizedPath;
    $scope.getCountriesList = SelectService.getCountriesList;

    $scope.isIncust = appConfig.platformParams.main_site.en === 'incust.com';
    $scope.isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';

    var codeReportPeriodEmpty = 34;

    var filterTimeout, showTariffsTimeout;

    var block_tariff_details = blockUI.instances.get('tariff_details');
    var block_tariff = blockUI.instances.get('tariff');

    initController();

    // *********************************************************************************************
    //  MAIN PART
    // *********************************************************************************************

    /**
     * Page mode display differed parts. Now 'show', 'create', 'edit'.
     * Use as <ANY ng-if="isPageMode('show')">
     */
    function isPageMode(mode) {
      return mode == $scope._pageMode;
    }

    /**
     * Initialize page mode by url
     */
    function initPageMode() {
      $scope._pageMode = 'tariff';
      if ($routeParams['mode'] && ['details', 'sms-details', 'viber-details'].indexOf($routeParams['mode']) > -1) {
        $scope._pageMode = $routeParams['mode'];
      }
    }

    /**
     * Initialize controller
     */
    function initController() {
      $scope.business = angular.copy($rootScope.ENV.business);

      getLegalInfo();

      imgToDataUrl('/assets/img/payment/seal.png', function(img) {
        $scope.img_seal = img;
      });
      imgToDataUrl('/assets/img/payment/sign.png', function(img) {
        $scope.img_sign = img;
      });
      imgToDataUrl('/assets/img/logo-sign.png', function(img) {
        $scope.img_logo = img;
      });

      initPageMode();

      switch ($scope._pageMode) {
        case 'tariff':
          doShowTariff();
          break;
        case 'details':
          $rootScope.PAGE.title = 'Invoices and Finance';
          doShowDetails();
          break;
        case 'sms-details':
          doShowSMSDetails();
          break;
        case 'viber-details':
          doShowViberDetails();
          break;
      }
    }

    // *********************************************************************************************
    //  SHOW TARIFF PART
    // *********************************************************************************************

    /**
     * Prepare data for display page in mode 'show tariff'
     */
    function doShowTariff() {
      // Wait when business loading
      // var unbind = $rootScope.$watch('BUSINESS', function (newValue, oldValue) {
      //     if (newValue) {
      //         $scope.tariff = $rootScope.BUSINESS.tariff;
      //         unbind();
      //     }
      // });
      block_tariff.start();
      BusinessService.GetWithTariff(function(success, response) {
        if (success) {
          $scope.tariff = $rootScope.BUSINESS.tariff;
          delete response.auto_pay_params;
          $scope.business = response;
          $rootScope.storeENV();
          if ($routeParams.isChangeTariff === 1) {
            $scope.popupUpgradePlan();
          }
        }

        block_tariff.stop();
      });
    }

    // $scope.onSMSDetailsClick = function () {
    //     $location.path('/tariff/sms-details');
    // };

    // *********************************************************************************************
    //  SHOW TARIFF DETAILS PART
    // ********************************************************************************************

    /**
     * Prepare data for display page in mode 'show tariff'
     */
    function doShowDetails() {
      var d = new Date();
      var m = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      var start_year = 2016;
      var years = [start_year];
      if (d.getFullYear() > start_year) {
        for (var i = start_year + 1; i <= d.getFullYear(); i++) {
          years.push(i);
        }
      }

      $scope.staff = {
        months: m,
        month: m[d.getMonth()],
        year: years[years.length - 1],
        years: years,
        filter: 'show_all'
      };

      onShowTariffDetails(true, function(success, data) { });
    }

    // function _getTariffDetails(callback) {
    //     block_tariff_details.start();
    //     BusinessService.TariffDetails(null, function (success, data) {
    //         $scope.emptyDetails = data.code == codeReportPeriodEmpty;
    //         if ($scope.emptyDetails) {
    //             NotifyService.Warning(data.message, false);
    //         }
    //         $scope.tariffDetails = data;
    //         callback(success, data);

    //         block_tariff_details.stop();
    //     });
    // }

    function onShowTariffDetails(period, callback, language) {
      var p;
      if (period)
        p = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1);

      block_tariff_details.start();
      BusinessService.TariffDetails(p, function(success, data) {
        if (!language) {
          $scope.emptyDetails = data.code == codeReportPeriodEmpty;
          if ($scope.emptyDetails) {
            NotifyService.Warning(data.message, false);
          }
          $scope.tariffDetails = data;

          if (!$scope.tariffDetails.period_discount_amount)
            $scope.tariffDetails.period_discount_amount = 0;
          if (!$scope.tariffDetails.period_business_bonuses_redeemed_amount)
            $scope.tariffDetails.period_business_bonuses_redeemed_amount = 0;
          if (!$scope.tariffDetails.period_refill_payment_amount)
            $scope.tariffDetails.period_refill_payment_amount = 0;
        }
        $scope.tariffDetailsPublicLangage = data;
        callback(success, data);
        block_tariff_details.stop();
      }, language);
    }

    $scope.onShowTariffDetailsClick = function() {
      onShowTariffDetails(true, function(success) { });
    };

    $scope.onFilterChange = function() {
      // onShowTariffDetails(true, function(success){ });
    };

    $scope.isBillingExist = function() {
      var result = $scope.tariffDetails && $scope.tariffDetails.billing && $scope.tariffDetails.billing.length > 0;
      if (result && $scope.staff.filter != 'show_all') {
        result = false;
        $scope.tariffDetails.billing.forEach(function(item) {
          if (item.type == $scope.staff.filter) result = true;
        });
      }
      return result;
    };

    // *********************************************************************************************
    //  SHOW SMS TARIFF PART
    // ********************************************************************************************

    function showSMSTariff() {
      var params = {
        country: $scope.staff.country,
        page: $scope.staff.pager.page,
        count: $scope.staff.pager.count
      };

      BusinessService.SMSTariff(params, function(success, data) {
        $scope.smsTariff = data.data;
        $scope.summary = data.summary;
        $scope.staff.pager.total_rows_count = data.summary.total_rows_count;
      });
    }

    function showViberTariff() {
      var params = {
        country: $scope.staff.country,
        page: $scope.staff.pager.page,
        count: $scope.staff.pager.count
      };

      BusinessService.ViberTariff(params, function(success, data) {
        $scope.viberTariff = data.data;
        $scope.summary = data.summary;
        $scope.staff.pager.total_rows_count = data.summary.total_rows_count;
      });
    }

    function doShowSMSDetails() {
      if ($rootScope.ENV.business.country) {
        $scope.staff.country = $rootScope.ENV.business.country;
        showSMSTariff();

        $timeout.cancel(showTariffsTimeout);
      } else {
        showTariffsTimeout = $timeout(doShowSMSDetails, 250);
      }
    }

    function doShowViberDetails() {
      if ($rootScope.ENV.business.country) {
        $scope.staff.country = $rootScope.ENV.business.country;
        showViberTariff();

        $timeout.cancel(showTariffsTimeout);
      } else {
        showTariffsTimeout = $timeout(doShowViberDetails, 250);
      }
    }

    /**
     * Received when user chane page
     */
    $scope.pageChange = function(loc) {
      switch (loc) {
        case 'sms':
          showSMSTariff();
          break;
        case 'viber':
          showViberTariff();
          break;
      }
    };

    /**
     * handling items on page count
     */
    $scope.onCountChange = function(count, loc) {
      $scope.staff.pager.page = 1;
      $scope.staff.pager.count = count;

      switch (loc) {
        case 'sms':
          showSMSTariff();
          break;
        case 'viber':
          showViberTariff();
          break;
      }

    };

    $scope.getChargesTitle = function(t) {

      var l = $scope.data.tariff_details_filters;
      for (var i in l)
        if (l[i].id === t) {
          return 'title_period_' + l[i].title;
        }

      return '';
    };

    var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
      doShowTariff();
    });

    $scope.$on('$destroy', unbindTranslateChangeSuccess);

    function popupBonusesRedeem() {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: true,
        templateUrl: 'app/templates/modal.business.bonuses_redeem.html',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;

          onShowTariffDetails(false, function(success, data) {
            popup.business_bonuses_amount = $scope.business.status.business_bonuses_amount;
            popup.period_ordered_and_provided_services_amount = $scope.tariffDetails.period_ordered_and_provided_services_amount;
            popup.period_business_bonuses_redeemed_amount = $scope.tariffDetails.period_business_bonuses_redeemed_amount;
            if (popup.period_ordered_and_provided_services_amount - popup.period_business_bonuses_redeemed_amount >= 0)
              popup.available_bonuses_redeem_amount = popup.period_ordered_and_provided_services_amount -
                  popup.period_business_bonuses_redeemed_amount;
            else
              popup.available_bonuses_redeem_amount = 0.00;
          });

          popup.onBonusesAmountChange = function() {
            if (!popup.bonuses_redeem_amount)
              popup.bonuses_redeem_amount = 0.00;

            var redeem_limit = 0.00;

            if (popup.business_bonuses_amount >= popup.available_bonuses_redeem_amount)
              redeem_limit = popup.available_bonuses_redeem_amount;
            else
              redeem_limit = popup.business_bonuses_amount;

            if (popup.bonuses_redeem_amount > redeem_limit)
              popup.bonuses_redeem_amount = roundDecimals(redeem_limit, 2);

          };

          popup.onOk = function(exit) {
            if (!popup.isBonusesRedeemed) {
              var post_data = {
                amount: popup.bonuses_redeem_amount,
                currency: $scope.business.currency
              };

              BusinessService.AccountBonusesRedeem(post_data, function(success, response) {
                if (success) {
                  popup.business_bonuses_amount = $scope.business.status.business_bonuses_amount
                      = response.business_bonuses_amount;
                  popup.period_business_bonuses_redeemed_amount += popup.bonuses_redeem_amount;
                  popup.isBonusesRedeemed = true;
                  $rootScope.getBusinessStatus();
                }
              });
            } else {
              $uibModalInstance.close();
            }
          };

          popup.onCancel = function(exit) {
            $uibModalInstance.close();
          };
        }
      });
    }

    function getLegalInfo() {
      BusinessService.LegalInfo(function(success, data) {
        if (success) {
          $scope.legal_info = data;

          $scope.legal_info.customer_representative = '';
          if ($rootScope.USER.name)
            $scope.legal_info.customer_representative += $rootScope.USER.name + ', ';
          if ($rootScope.USER.phone)
            $scope.legal_info.customer_representative += $rootScope.USER.phone + ', ';
          if ($rootScope.USER.login)
            $scope.legal_info.customer_representative += $rootScope.USER.login;

          $scope.legal_info.user_name = $rootScope.USER.name;
          $scope.legal_info.user_phone = $rootScope.USER.phone;
          $scope.legal_info.user_email = $rootScope.USER.login;

          $scope.legal_info.account_owner_details = '';
          if ($rootScope.USER.name)
            $scope.legal_info.account_owner_details += $rootScope.USER.name + '\n';
          if ($rootScope.USER.phone)
            $scope.legal_info.account_owner_details += $rootScope.USER.phone + ', ';
          if ($rootScope.USER.login)
            $scope.legal_info.account_owner_details += $rootScope.USER.login;
        }
      });
    }

    function roundDecimals(num, pos) {
      return (Math.round(num * Math.pow(10, pos)) / Math.pow(10, pos));
    }

    $scope.onTariffUpgradeClick = function() {
      if ($scope.business.status.account_balance <= 0)
        $scope.inlineMessage = 'TEXT_WARNING_FUNDS_REFILL_REMIND';
      else if ($scope.business.status.account_balance > 0)
        var modalInstance = $uibModal.open({
          animation: true,
          keyboard: true,
          size: 'md',
          templateUrl: 'app/templates/modal.confirmation.html',
          controllerAs: 'popup',
          controller: function($uibModalInstance) {
            var popup = this;

            popup.type = 'tariff';

            popup.onOkClick = function(exit) {
              BusinessService.TariffChange(function(success, response) {
                console.log('UPDATE TARIFF', response);

                $scope.business = response;
                $scope.tariff = response.tariff;

                $rootScope.ENV.business = response;
                $rootScope.storeENV();
                NotifyService.Success($translate.instant('TEXT_TARIFF_CHANGED_SUCCESSFULLY'), false);
                $uibModalInstance.close();
              });
            };

            popup.onCancelClick = function(exit) {
              $uibModalInstance.close();
            };
          }
        });
    };

    $scope.onDownloadPDF = function(event) {

      $scope.isInvoiceFilePrepering = true;

      onShowTariffDetails(true, function(success) {
        console.log('onShowTariffDetails', success);
        $timeout(function() {
          var file_name = $rootScope.ENV.business.code + '_invoice_' +
              moment($scope.tariffDetails.period_begin_datetime).format('YYYY-MM-DD') + '_' +
              moment($scope.tariffDetails.period_end_datetime).format('YYYY-MM-DD');

          switch ($scope.business.country) {
            case 'UA':
              prepareInvoiceUA(function(pdf_data) {
                pdfMake.createPdf(pdf_data).download(file_name, function() {
                  $scope.$apply(function() { $scope.isInvoiceFilePrepering = false; });
                });
              });
              break;
            case 'RU':
              prepareInvoiceRU(function(pdf_data) {
                pdfMake.createPdf(pdf_data).download(file_name, function() {
                  $scope.$apply(function() { $scope.isInvoiceFilePrepering = false; });
                });
              });
              break;
            default:
              prepareInvoiceEN(function(pdf_data) {
                pdfMake.createPdf(pdf_data).download(file_name, function() {
                  $scope.$apply(function() { $scope.isInvoiceFilePrepering = false; });
                });
              });
          }
        }, 500);
      });
    };

    $scope.onDownloadPDFDetailed = function() {
      $scope.isInvoiceDetailedFilePrepering = true;
      var pdfLanguage;

      switch ($scope.business.country) {
        case 'UA':
          pdfLanguage = 'uk';
          break;
        case 'RU':
          pdfLanguage = 'ru';
          break;
        default:
          pdfLanguage = 'en';
      }
      onShowTariffDetails(true, function(success) {
        $timeout(function() {
          var file_name = $rootScope.ENV.business.code + '_report_' +
              moment($scope.tariffDetails.period_begin_datetime).format('YYYY-MM-DD') + '_' +
              moment($scope.tariffDetails.period_end_datetime).format('YYYY-MM-DD');
          switch ($scope.business.country) {
            case 'UA':
              prepareInvoiceDetailedUA(function(pdf_data) {
                pdfMake.createPdf(pdf_data).download(file_name, function() {
                  $scope.$apply(function() { $scope.isInvoiceDetailedFilePrepering = false; });
                });
              });
              break;
            case 'RU':
              prepareInvoiceDetailedRU(function(pdf_data) {
                pdfMake.createPdf(pdf_data).download(file_name, function() {
                  $scope.$apply(function() { $scope.isInvoiceDetailedFilePrepering = false; });
                });
              });
              break;
            default:
              prepareInvoiceDetailedEN(function(pdf_data) {
                pdfMake.createPdf(pdf_data).download(file_name, function() {
                  $scope.$apply(function() { $scope.isInvoiceDetailedFilePrepering = false; });
                });
              });
          }
        }, 500);
      }, 'en');
      // pdfMake.createPdf($scope.invoicePdf).open();
    };

    function prepareInvoiceUA(callback) {
      var current_language = $rootScope.LANG;

      $translate.use('uk').then(function() {
        var services_list = [
              [
                {text: 'Назва послуги', style: 'text', bold: true},
                {text: 'Разом, грн', style: 'text', bold: true, alignment: 'right'}]],
            services_list_amount = 0.00,
            td = $scope.tariffDetails,
            funds_income = td.period_refill_payment_amount - (td.period_discount_amount + td.period_business_bonuses_redeemed_amount),
            discount_result = td.period_discount_amount + td.period_business_bonuses_redeemed_amount,
            period_refill_credit_payment_amount = td.period_refill_credit_payment_amount,
            discount_result_string = $filter('number')(discount_result, 2),
            period = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1),
            invoice_number = '',
            legal_info = '';

        if (!$scope.business.referral_code)
          $scope.business.referral_code = 'відсутній';

        for (var i in $scope.data.tariff_details_options) {
          var v = 'period_' + $scope.data.tariff_details_options[i];
          if (td[v] > 0) {
            services_list.push([
              {text: $translate.instant('title_' + v), style: 'text'},
              {text: $filter('number')(td[v], 2), style: 'text', alignment: 'right'}]);
            services_list_amount += td[v];
          }
        }

        services_list.push([
          {
            text: 'Замовлено та надано послуг за період ' + $filter('date')(td.period_begin_datetime, 'dd.MM.yyyy') + ' 00:00 (UTC) - ' +
                $filter('date')(td.period_end_datetime, 'dd.MM.yyyy') + ' 23:59 UTC', style: 'text', bold: true, colSpan: 2
          }]);
        services_list.push(
            [{text: 'Разом', style: 'text'}, {text: $filter('number')(services_list_amount, 2), style: 'text', alignment: 'right'}]);
        services_list.push([
          {text: 'Знижка', style: 'text'},
          {text: ((discount_result > 0) ? '-' : '') + discount_result_string, style: 'text', alignment: 'right'}]);
        services_list.push([
          {text: 'Всього (без ПДВ)', bold: true, style: 'text'},
          {
            text: $filter('number')(services_list_amount - td.period_discount_amount - td.period_business_bonuses_redeemed_amount, 2),
            style: 'text',
            bold: true,
            alignment: 'right'
          }]);

        if (($scope.staff.months.indexOf($scope.staff.month) + 1) == moment().format('M'))
          invoice_number = 'АКТ НАДАНИХ ПОСЛУГ №' + $scope.business.status.business_code + '-' + moment().format('YYYYMMDDHHmm') + ' від ' +
              moment().format('DD.MM.YYYY');
        else
          invoice_number = 'АКТ НАДАНИХ ПОСЛУГ №' + $scope.business.status.business_code + '-' +
              moment(period).endOf('month').format('YYYYMMDD') + ' від ' + moment(period).endOf('month').format('DD.MM.YYYY');

        if ($scope.legal_info.name_for_invoice) {
          legal_info += $scope.legal_info.name_for_invoice;
        } else {
          legal_info += $scope.legal_info.user_name;
        }

        if ($scope.legal_info.accounting_phone) {
          legal_info += '\n' + $scope.legal_info.accounting_phone;
        } else {
          legal_info += '\n' + $scope.legal_info.user_phone;
        }

        if ($scope.legal_info.accounting_email) {
          legal_info += '\n' + $scope.legal_info.accounting_email;
        } else {
          legal_info += '\n' + $scope.legal_info.user_email;
        }

        if ($scope.legal_info.legal_address)
          legal_info += '\nЮридичная адреса: ' + $scope.legal_info.legal_address;
        if ($scope.legal_info.post_address)
          legal_info += '\nДля листування: ' + $scope.legal_info.post_address;
        if ($scope.legal_info.accounting_phone)
          legal_info += '\nБухгалтерія: ' + $scope.legal_info.accounting_phone;
        if ($scope.legal_info.accounting_email)
          legal_info += ', ' + $scope.legal_info.accounting_email;
        var invoiceInfo, paymentInfo, signInfo;
        if ($scope.isIncust) {
          invoiceInfo = {
            text: 'ТОВ “СОФТПАНОРАМА ПЛЮС ПЛЮС”' + '\n' + 'Юридична адреса: Україна 02152, м.Київ, пр-т Тичини, 20\n' +
                'Для листування: 02081 м.Київ , вул.Урлівська, 11а, оф.69\n' +
                'Бухгалтерія: 38 044 394-95-94, uaacc@incust.com\n' +
                'Тел.: 38 044 394-95-94', style: 'text'
          };
          paymentInfo = {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Платіжні реквізити:',
                    style: 'text', bold: true
                  }],
                [
                  {
                    text: 'IBAN UA58 305299 00000 26000036224392 в АТ КБ "ПРИВАТБАНК"\n' +
                        'МФО 305299, ЄДРПОУ 32849350',
                    style: 'text'
                  }
                ]
              ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 10]
          },
              signInfo = [
                {
                  text: [
                    'Заборгованість підлягає оплаті в особистому кабінеті на www.incust.com. При несвоєчасній оплаті надання послуг може бути призупинено. ',
                    'Цей акт, сформований білінгової системою Виконавця, є первинним документом, що підтверджує надання Виконавцем послуг Замовникові у відповідному розрахунковому періоді. Акт зберегаеться у Замовника і, при необхідності, може бути скріплений підписом і печаткою Замовника.'],
                  fontSize: 7,
                  margin: [0, 0, 0, 10]
                },
                {
                  table: {
                    widths: [150, '*'],
                    body: [
                      [
                        {text: 'Виконавець:', style: 'text'},
                        {text: ' ', style: 'text'}],
                      [
                        {text: 'Підпис:', style: 'text'},
                        {text: '__________________________', style: 'text'}],
                      [
                        {text: 'М.П.', style: 'text'},
                        {text: 'Директор: Федченко В. О.', style: 'text'}]
                    ]
                  },
                  layout: 'noBorders',
                  margin: [0, 0, 0, 10]
                },
                {
                  table: {
                    widths: [150, '*'],
                    body: [
                      [
                        {text: 'Замовник:', style: 'text'},
                        {text: ' ', style: 'text'}],
                      [
                        {text: 'Підпис:', style: 'text'},
                        {text: '__________________________', style: 'text'}],
                      [
                        {text: 'М.П.', style: 'text'},
                        {text: '', style: 'text'}]
                    ]
                  },
                  layout: 'noBorders'
                },
                {
                  image: $scope.img_seal,
                  width: 90,
                  margin: [150, -120, 0, 0]
                },
                {
                  image: $scope.img_sign,
                  width: 80,
                  margin: [160, -70, 0, 0]
                },
                {
                  image: $scope.img_logo,
                  width: 50,
                  alignment: 'right',
                  margin: [0, -30, 0, 15]
                }];
        } else if ($scope.isPrimeFuel) {
          invoiceInfo = {
            text: 'Prime Fuels LLC' + '\n' + 'Юридична адреса: 280 50516 Range Road 233\n' +
                'Leduc County Alberta T4X0L4\n' +
                'prime-fuel.com\n' +
                'info@globalengmfg.com, Тел.: +61 (7) 31028365', style: 'text'
          };
          paymentInfo = {};
          signInfo = [
            {
              text: ['Інструкції щодо оплати: для оплати перейдіть на сторінку свого облікового запису на сайті PrimeFuel: https://b.prime-fuel.com/payment'],
              fontSize: 10,
              margin: [0, 0, 0, 10]
            }];
        }

        var pdf_data = {
          pageSize: 'A4',
          pageMargins: [40, 40, 40, 20],
          content: [
            {
              image: $scope.img_logo,
              width: 80,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [invoice_number],
              style: 'header',
              alignment: 'center',
              margin: [0, 0, 0, 5]
            },
            {
              text: ['Дата друка ' + moment().format('DD.MM.YYYY') + ' р.' + moment().format('HH:mm')],
              style: 'text',
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [130, '*'],
                body: [
                  [
                    {text: 'Особовий рахунок Замовника:', style: 'text'},
                    {text: $scope.business.status.business_code, style: 'text'}],

                  [
                    {text: 'Ref ID:', style: 'text'},
                    {text: $scope.business.referral_code, style: 'text'}],

                  [
                    {text: 'Представник Замовника:', style: 'text'},
                    {text: $scope.legal_info.customer_representative, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [300, '*'],
                body: [
                  [
                    invoiceInfo,
                    {text: legal_info, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 20]
            },
            paymentInfo,
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Залишок коштів на початок періоду: ' + moment(td.period_begin_datetime).utc().format('DD.MM.YYYY') +
                          ' 00:00 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_begin_balance_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Надходження коштів на рахунок за період',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_refill_payment_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Надходження кредитних коштів на рахунок за період',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(period_refill_credit_payment_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Сума замовлених і наданих послуг за період',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_ordered_and_provided_services_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Надана знижка',
                      style: 'text'
                    },
                    {
                      text: $filter('number')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Залишок коштів на кінець періоду: ' + moment(td.period_end_datetime).utc().format('DD.MM.YYYY') + ' 23:59 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_end_balance_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 0]
            },
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Сума рекомендованого авансового платежу ',
                      bold: true, style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_recommended_advance_payment_amount, 2) + ' грн.',
                      style: 'text', bold: true, alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0;
                },
                vLineWidth: function(i, node) {
                  return 0;
                },
                paddingLeft: function(i, node) { return 4; },
                paddingRight: function(i, node) { return 4; },
                paddingTop: function(i, node) { return 2; },
                paddingBottom: function(i, node) { return 2; }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Деталізована інформація по замовленим і наданим послугам'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: ['*', 70],
                body: services_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 10]
            },

            signInfo[0] ? signInfo[0] : [],
            signInfo[1] ? signInfo[1] : [],
            signInfo[2] ? signInfo[2] : [],
            signInfo[3] ? signInfo[3] : [],
            signInfo[4] ? signInfo[4] : [],
            signInfo[5] ? signInfo[5] : []

          ],
          defaultStyle: {
            font: 'calibri'
          },
          styles: {
            header: {
              bold: true,
              fontSize: 16
            },
            text: {
              fontSize: 9
            }
          }
        };

        $translate.use(current_language);
        callback(pdf_data);
      });
    }

    function prepareInvoiceRU(callback) {
      var current_language = $rootScope.LANG;

      $translate.use('ru').then(function() {
        var services_list = [
              [
                {text: 'Название услуги', style: 'text', bold: true},
                {text: 'Итого, руб', style: 'text', bold: true, alignment: 'right'}]],
            services_list_amount = 0.00,
            td = $scope.tariffDetails,
            funds_income = td.period_refill_payment_amount - (td.period_discount_amount + td.period_business_bonuses_redeemed_amount),
            discount_result = td.period_discount_amount + td.period_business_bonuses_redeemed_amount,
            period_refill_credit_payment_amount = td.period_refill_credit_payment_amount,
            discount_result_string = $filter('number')(discount_result, 2),
            period = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1),
            invoice_number = '',
            legal_info = '';

        if (!$scope.business.referral_code)
          $scope.business.referral_code = 'отсутствует';

        for (var i in $scope.data.tariff_details_options) {
          var v = 'period_' + $scope.data.tariff_details_options[i];
          if (td[v] > 0) {
            services_list.push([
              {text: $translate.instant('title_' + v), style: 'text'},
              {text: $filter('number')(td[v], 2), style: 'text', alignment: 'right'}]);
            services_list_amount += td[v];
          }
        }

        services_list.push([
          {
            text: 'Заказано и предоставлено услуг за период ' + $filter('date')(td.period_begin_datetime, 'dd.MM.yyyy') +
                ' 00:00 (UTC) - ' + $filter('date')(td.period_end_datetime, 'dd.MM.yyyy') + ' 23:59 UTC',
            style: 'text',
            bold: true,
            colSpan: 2
          }]);
        services_list.push(
            [{text: 'Итого', style: 'text'}, {text: $filter('number')(services_list_amount, 2), style: 'text', alignment: 'right'}]);
        services_list.push([
          {text: 'Скидка', style: 'text'},
          {text: ((discount_result > 0) ? '-' : '') + discount_result_string, style: 'text', alignment: 'right'}]);
        services_list.push([
          {text: 'Всего (без НДС)', bold: true, style: 'text'},
          {
            text: $filter('number')(services_list_amount - td.period_discount_amount - td.period_business_bonuses_redeemed_amount, 2),
            style: 'text',
            bold: true,
            alignment: 'right'
          }]);

        if (($scope.staff.months.indexOf($scope.staff.month) + 1) == moment().format('M'))
          invoice_number = 'АКТ ОКАЗАННЫХ УСЛУГ №' + $scope.business.status.business_code + '-' + moment().format('YYYYMMDDHHmm') + ' от ' +
              moment().format('DD.MM.YYYY');
        else
          invoice_number = 'АКТ ОКАЗАННЫХ УСЛУГ №' + $scope.business.status.business_code + '-' +
              moment(period).endOf('month').format('YYYYMMDD') + ' от ' + moment(period).endOf('month').format('DD.MM.YYYY');

        if ($scope.legal_info.name_for_invoice) {
          legal_info += $scope.legal_info.name_for_invoice;
        } else {
          legal_info += $scope.legal_info.user_name;
        }

        if ($scope.legal_info.accounting_phone) {
          legal_info += '\n' + $scope.legal_info.accounting_phone;
        } else {
          legal_info += '\n' + $scope.legal_info.user_phone;
        }

        if ($scope.legal_info.accounting_email) {
          legal_info += '\n' + $scope.legal_info.accounting_email;
        } else {
          legal_info += '\n' + $scope.legal_info.user_email;
        }

        if ($scope.legal_info.legal_address)
          legal_info += '\nЮридический адрес: ' + $scope.legal_info.legal_address;
        if ($scope.legal_info.post_address)
          legal_info += '\nДля корреспонденции: ' + $scope.legal_info.post_address;
        if ($scope.legal_info.accounting_phone)
          legal_info += '\nБухгалтерия: ' + $scope.legal_info.accounting_phone;
        if ($scope.legal_info.accounting_email)
          legal_info += ', ' + $scope.legal_info.accounting_email;
        var invoiceInfo, paymentInfo, signInfo;
        if ($scope.isIncust) {
          invoiceInfo = {
            text: 'ООО “СОФТПАНОРАМА ПЛЮС ПЛЮС”' + '\n' + 'Юридический адрес: Украина 02152, г.Киев, пр-т Тычины, 20\n' +
                'Для корреспонденции: 02081 г.Киев , ул.Урловская, 11а, оф.69\n' +
                'Бухгалтерия: 38 044 220-15-15, uaacc@incust.com\n' +
                'Тел.: 38 044 394-95-94', style: 'text'
          };
          paymentInfo = {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Платежные реквизиты:',
                    style: 'text', bold: true
                  }],
                [
                  {
                    text: 'Beneficiary: Softpanorama plus plus limited liability partnership\n' +
                        'Account #: UA573007110000026006052695978\n' +
                        'Beneficiary’s bank:  JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE\n' +
                        'SWIFT code :  PBANUA2X\n' +
                        'CORRESPONDENT BANKS: ОАО Белинвестбанк,Минск, Беларусь\n' +
                        'Account in the correspondent bank BY61BLBB17020009999920100001\n' +
                        'SWIFT Code of the correspondent bank BLBBBY2XXXX\n' +
                        'Сorrespondent′s bank аccount in the intermediary bank 30111810800000000154\n' +
                        'Intermediary bank ПАО СБЕРБАНК, Москва, Россия\n' +
                        'SWIFT, БИК, ІПН, КПП БАНКА-ПОСРЕДНИКА/IDENTIFICATION CODE OF THE INTERMEDIARY BANK\n' +
                        'SABRRUMM,044525225,7707083893,775001001\n' +
                        'НОМЕР РАХУНКУ БАНКА-ПОСЕРЕДНИКА В ГУ Банка Росії по ЦФО 30101810400000000225\n',
                    style: 'text'
                  }]
              ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 10]
          },
              signInfo = [
                {
                  text: [
                    'Задолженность подлежит оплате в личном кабинете на www.incust.com. При несвоевременной оплате предоставление услуг может быть приостановлено. ',
                    'Этот Акт, сформированный биллинговой системой Исполнителя, является первичным документом, подтверждающим предоставление Исполнителем услуг Заказчику в соответствующем расчетном периоде. Акт сохраняется у Заказчика и, при необходимости, может быть скреплен подписью и печатью Заказчика.'],
                  fontSize: 7,
                  margin: [0, 0, 0, 10]
                },
                {
                  table: {
                    widths: [150, '*'],
                    body: [
                      [
                        {text: 'Исполнитель:', style: 'text'},
                        {text: ' ', style: 'text'}],
                      [
                        {text: 'Подпись:', style: 'text'},
                        {text: '__________________________', style: 'text'}],
                      [
                        {text: 'М.П.', style: 'text'},
                        {text: 'Директор: Федченко В. О.', style: 'text'}]
                    ]
                  },
                  layout: 'noBorders',
                  margin: [0, 0, 0, 10]
                },
                {
                  table: {
                    widths: [150, '*'],
                    body: [
                      [
                        {text: 'Заказчик:', style: 'text'},
                        {text: ' ', style: 'text'}],
                      [
                        {text: 'Подпись:', style: 'text'},
                        {text: '__________________________', style: 'text'}],
                      [
                        {text: 'М.П.', style: 'text'},
                        {text: '', style: 'text'}]
                    ]
                  },
                  layout: 'noBorders'
                },
                {
                  image: $scope.img_logo,
                  width: 50,
                  alignment: 'right',
                  margin: [0, -30, 0, 15]
                }];

        } else if ($scope.isPrimeFuel) {
          invoiceInfo = {
            text: 'Prime Fuels LLC' + '\n' + 'Юридический адрес: 280 50516 Range Road 233\n' +
                'Leduc County Alberta T4X0L4\n' +
                'prime-fuel.com\n' +
                'info@globalengmfg.com, Тел.: +61 (7) 31028365', style: 'text'
          };
          paymentInfo = {};
          signInfo = [
            {
              text: ['Инструкции по оплате: Для оплаты перейдите на страницу своей учетной записи на сайте PrimeFuel: https://b.prime-fuel.com/payment'],
              fontSize: 10,
              margin: [0, 0, 0, 10]
            }];
        }
        var pdf_data = {
          pageSize: 'A4',
          pageMargins: [40, 40, 40, 20],
          content: [
            {
              image: $scope.img_logo,
              width: 80,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [invoice_number],
              style: 'header',
              alignment: 'center',
              margin: [0, 0, 0, 5]
            },
            {
              text: ['Дата печати ' + moment().format('DD.MM.YYYY') + ' г.' + moment().format('HH:mm')],
              style: 'text',
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [130, '*'],
                body: [
                  [
                    {text: 'Личный счет Заказчика:', style: 'text'},
                    {text: $scope.business.status.business_code, style: 'text'}],

                  [
                    {text: 'Ref ID:', style: 'text'},
                    {text: $scope.business.referral_code, style: 'text'}],

                  [
                    {text: 'Представитель Заказчика:', style: 'text'},
                    {text: $scope.legal_info.customer_representative, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [300, '*'],
                body: [
                  [
                    invoiceInfo,
                    {text: legal_info, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            paymentInfo,
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Остаток средств на начало периода: ' + moment(td.period_begin_datetime).utc().format('DD.MM.YYYY') +
                          ' 00:00 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_begin_balance_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Поступление средств на счет за период',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_refill_payment_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Поступление кредитных средств на счет за период',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(period_refill_credit_payment_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Сумма заказанных и оказанных услуг за период',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_ordered_and_provided_services_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Предоставленная скидка',
                      style: 'text'
                    },
                    {
                      text: $filter('number')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Остаток средств на конец периода: ' + moment(td.period_end_datetime).utc().format('DD.MM.YYYY') + ' 23:59 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_end_balance_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 0]
            },
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Сумма рекомендованного авансового платежа ',
                      bold: true, style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_recommended_advance_payment_amount, 2) + ' руб.',
                      style: 'text', bold: true, alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0;
                },
                vLineWidth: function(i, node) {
                  return 0;
                },
                paddingLeft: function(i, node) { return 4; },
                paddingRight: function(i, node) { return 4; },
                paddingTop: function(i, node) { return 2; },
                paddingBottom: function(i, node) { return 2; }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Детализированная информация по заказанным и оказанным услугам'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: ['*', 70],
                body: services_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 10]
            },
            signInfo[0] ? signInfo[0] : [],
            signInfo[1] ? signInfo[1] : [],
            signInfo[2] ? signInfo[2] : [],
            signInfo[3] ? signInfo[3] : []

          ],
          defaultStyle: {
            font: 'calibri'
          },
          styles: {
            header: {
              bold: true,
              fontSize: 16
            },
            text: {
              fontSize: 8
            }
          }
        };

        $translate.use(current_language);
        callback(pdf_data);
      });
    }

    function prepareInvoiceEN(callback) {
      var current_language = $rootScope.LANG;

      $translate.use('en').then(function() {
        var services_list = [[{text: 'Name', style: 'text', bold: true}, {text: 'Value', style: 'text', bold: true, alignment: 'right'}]],
            services_list_amount = 0.00,
            td = $scope.tariffDetails,
            currency = $scope.tariffDetails.billing.length > 0 ? $scope.tariffDetails.billing[0].currency : ' ',
            funds_income = td.period_refill_payment_amount - (td.period_discount_amount + td.period_business_bonuses_redeemed_amount),
            discount_result = td.period_discount_amount + td.period_business_bonuses_redeemed_amount,
            period_refill_credit_payment_amount = td.period_refill_credit_payment_amount,
            discount_result_string = $filter('number')(discount_result, 2),
            period = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1),
            invoice_number = '',
            legal_info = '';

        if (!$scope.business.referral_code)
          $scope.business.referral_code = '-';

        for (var i in $scope.data.tariff_details_options) {
          var v = 'period_' + $scope.data.tariff_details_options[i];
          if (td[v] > 0) {
            services_list.push([
              {text: $translate.instant('title_' + v), style: 'text'},
              {text: $filter('number')(td[v], 2), style: 'text', alignment: 'right'}]);
            services_list_amount += td[v];
          }
        }

        services_list.push(
            [{text: 'Total', style: 'text'}, {text: $filter('number')(services_list_amount, 2), style: 'text', alignment: 'right'}]);
        services_list.push([
          {text: 'Discount', style: 'text'},
          {text: ((discount_result > 0) ? '-' : '') + discount_result_string, style: 'text', alignment: 'right'}]);

        if (($scope.staff.months.indexOf($scope.staff.month) + 1) == moment().format('M'))
          invoice_number = 'INVOICE #' + $scope.business.status.business_code + '-' + moment().format('YYYYMMDDHHmm') + ', ' +
              moment().format('DD.MM.YYYY');
        else
          invoice_number = 'INVOICE #' + $scope.business.status.business_code + '-' + moment(period).endOf('month').format('YYYYMMDD') +
              ', ' + moment(period).endOf('month').format('DD.MM.YYYY');

        if ($scope.legal_info.name_for_invoice) {
          legal_info += $scope.legal_info.name_for_invoice;
        } else {
          legal_info += $scope.legal_info.user_name;
        }

        if ($scope.legal_info.accounting_phone) {
          legal_info += '\n' + $scope.legal_info.accounting_phone;
        } else if ($scope.legal_info.user_phone) {
          legal_info += '\n' + $scope.legal_info.user_phone;
        }

        if ($scope.legal_info.accounting_email) {
          legal_info += '\n' + $scope.legal_info.accounting_email;
        } else {
          legal_info += '\n' + $scope.legal_info.user_email;
        }

        if ($scope.legal_info.legal_address)
          legal_info += '\nLegal address: ' + $scope.legal_info.legal_address;
        if ($scope.legal_info.post_address)
          legal_info += '\nMailing address: ' + $scope.legal_info.post_address;
        if ($scope.legal_info.accounting_phone)
          legal_info += '\nAccounting department: ' + $scope.legal_info.accounting_phone;
        if ($scope.legal_info.accounting_email)
          legal_info += ', ' + $scope.legal_info.accounting_email;
        var invoiceInfo, signInfo;
        if ($scope.isIncust) {
          invoiceInfo = {
            text: 'inCust Ltd.' + '\n' + '20-22 Wenlock Road\n' +
                'London, N1 7GU, UK\n' +
                'incust.com\n' +
                'mailto:info@incust.com, +44 800 060 8 424', style: 'text'
          };
          signInfo = [
            {
              text: ['Payment Instructions: In order to pay please visit your account page on inCust site: https://business.incust.com/payment'],
              fontSize: 10,
              margin: [0, 0, 0, 10]
            }];
        } else if ($scope.isPrimeFuel) {
          invoiceInfo = {
            text: 'Prime Fuels LLC' + '\n' + '280 50516 Range Road 233\n' +
                'Leduc County Alberta T4X0L4\n' +
                'prime-fuel.com\n' +
                'mailto:info@globalengmfg.com, +61 (7) 31028365', style: 'text'
          };
          signInfo = [
            {
              text: ['Payment Instructions: In order to pay please visit your account page on PrimeFuel site: https://business.prime-fuel.com/payment'],
              fontSize: 10,
              margin: [0, 0, 0, 10]
            }];
        }

        var pdf_data = {
          pageSize: 'A4',
          pageMargins: [40, 40, 40, 20],
          content: [
            {
              image: $scope.img_logo,
              width: 80,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [invoice_number],
              style: 'header',
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [
                'Billing Cycle: ' +
                moment(td.period_begin_datetime).utc().format('DD.MM.YYYY') +
                ' - ' +
                moment(td.period_end_datetime).utc().format('DD.MM.YYYY') +
                '. Printed: ' +
                moment().format('DD.MM.YYYY') +
                ' ' +
                moment().format('HH:mm')
              ],
              style: 'text',
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [130, '*'],
                body: [
                  [
                    {text: 'Account ID:', style: 'text'},
                    {text: $scope.business.status.business_code, style: 'text'}],

                  [
                    {text: 'Ref ID:', style: 'text'},
                    {text: $scope.business.referral_code, style: 'text'}],

                  [
                    {text: 'Account Owner Details:', style: 'text'},
                    {text: $scope.legal_info.customer_representative, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [300, '*'],
                body: [
                  [
                    invoiceInfo,
                    {text: legal_info, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Previous balance: ' + moment(td.period_begin_datetime).utc().format('DD.MM.YYYY') + ' 00:00 UTC',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_begin_balance_amount, 2),
                      text: $filter('currencyFormat')(td.period_begin_balance_amount, currency),
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Payments received during the period',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_refill_payment_amount, 2),
                      text: $filter('currencyFormat')(td.period_refill_payment_amount, currency),
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Receipt of credit funds to the account for the period',
                      style: 'text'
                    },
                    {
                      // text: '$ ' + $filter('number')(period_refill_credit_payment_amount, 2),
                      text: $filter('currencyFormat')(period_refill_credit_payment_amount, currency),
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Services provided during the period',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_ordered_and_provided_services_amount, 2),
                      text: $filter('currencyFormat')(td.period_ordered_and_provided_services_amount, currency),
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Discount',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), 2),
                      text: $filter('currencyFormat')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), currency),
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Outstanding balance: ' + moment(td.period_end_datetime).utc().format('DD.MM.YYYY') + ' 23:59 UTC',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_end_balance_amount, 2),
                      text: $filter('currencyFormat')(td.period_end_balance_amount, currency),
                      style: 'text', alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 0]
            },
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Recommended amount of advance payment ',
                      bold: true, style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_recommended_advance_payment_amount, 2),
                      text: $filter('currencyFormat')(td.period_recommended_advance_payment_amount, currency),
                      style: 'text', bold: true, alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0;
                },
                vLineWidth: function(i, node) {
                  return 0;
                },
                paddingLeft: function(i, node) { return 4; },
                paddingRight: function(i, node) { return 4; },
                paddingTop: function(i, node) { return 2; },
                paddingBottom: function(i, node) { return 2; }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Usage Charges'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: ['*', 70],
                body: services_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 0]
            },
            {
              table: {
                widths: ['*', 70],
                body: [
                  [
                    {text: 'Grand Total', bold: true, fontSize: 11},
                    {
                      // text: $filter('number')(services_list_amount - td.period_discount_amount - td.period_business_bonuses_redeemed_amount,
                      //     2) + ' ' + currency, fontSize: 11, bold: true, alignment: 'right'
                      text: $filter('currencyFormat')(
                          services_list_amount - td.period_discount_amount - td.period_business_bonuses_redeemed_amount, currency),
                      fontSize: 11,
                      bold: true,
                      alignment: 'right'
                    }
                    // {text: currency, fontSize: 11, bold: true, alignment: 'right'}
                  ]]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return (i === 0) ? 0 : 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 10]
            },
            signInfo[0] ? signInfo[0] : {}
          ],
          defaultStyle: {
            font: 'calibri'
          },
          styles: {
            header: {
              bold: true,
              fontSize: 16
            },
            text: {
              fontSize: 9
            }
          }
        };

        $translate.use(current_language);
        callback(pdf_data);
      });
    }

    function prepareInvoiceDetailedUA(callback) {
      var current_language = $rootScope.LANG;

      $translate.use('uk').then(function() {
        var income_list = [[{text: 'Дата', style: 'text', bold: true}, {text: 'Сума, грн', style: 'text', bold: true, alignment: 'right'}]],
            income_amount = 0.00,
            operation_list = [
              [
                {text: 'Дата', style: 'text', bold: true},
                {text: 'Назва послуги', style: 'text', bold: true},
                {text: 'Сума, грн', style: 'text', bold: true, alignment: 'right'}]],
            operation_amount = 0.00,
            td = $scope.tariffDetailsPublicLangage ? $scope.tariffDetailsPublicLangage : $scope.tariffDetails,
            billing = td.billing,
            period = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1),
            funds_income = td.period_refill_payment_amount - (td.period_discount_amount + td.period_business_bonuses_redeemed_amount),
            discount_result = td.period_discount_amount + td.period_business_bonuses_redeemed_amount,
            period_refill_credit_payment_amount = td.period_refill_credit_payment_amount,
            discount_result_string = $filter('number')(discount_result, 2),
            invoice_number = '',
            legal_info = '';

        if (!$scope.business.referral_code)
          $scope.business.referral_code = 'відсутній';

        for (var i in billing) {
          if (billing[i].type == 'refill') {
            income_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {text: $filter('number')(billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            income_amount += billing[i].amount;
          } else if (billing[i].type == 'refill-cancel') {
            income_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {text: $filter('number')('-' + billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            income_amount -= billing[i].amount;

            operation_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {
                text: billing[i].public_title ? billing[i].public_title : $translate.instant($scope.getChargesTitle(billing[i].type)) || '',
                style: 'text'
              },
              {text: $filter('number')('-' + billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            operation_amount -= billing[i].amount;
          } else {
            operation_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {
                text: billing[i].public_title ? billing[i].public_title : $translate.instant($scope.getChargesTitle(billing[i].type)) || '',
                style: 'text'
              },
              {text: $filter('number')(billing[i].amount, 2), style: 'text', alignment: 'right'}
            ]);
            operation_amount += billing[i].amount;
          }
        }

        income_list.push([
          {text: 'Разом', bold: true, style: 'text'},
          {text: $filter('number')(income_amount, 2), style: 'text', bold: true, alignment: 'right'}]);
        operation_list.push([
          {
            text: 'Замовлено та надано послуг за період ' +
                $filter('date')(td.period_begin_datetime, 'dd.MM.yyyy') + ' 00:00 (UTC) - ' +
                $filter('date')(td.period_end_datetime, 'dd.MM.yyyy') + ' 23:59 UTC',
            style: 'text', bold: true, colSpan: 2
          },
          {text: ' '},
          {text: ' '}]);
        operation_list.push([
          {text: 'Разом (без ПДВ)', bold: true, style: 'text', colSpan: 2},
          {text: ' '},
          {text: $filter('number')(operation_amount, 2), style: 'text', bold: true, alignment: 'right'}]);

        if (($scope.staff.months.indexOf($scope.staff.month) + 1) == moment().format('M'))
          invoice_number = 'ЗВІТ-ДЕТАЛІЗАЦІЯ НАДАНИХ ПОСЛУГ №' + $scope.business.status.business_code + '-' +
              moment().format('YYYYMMDDHHmm') + '-д\nвід ' + moment().format('DD.MM.YYYY');
        else
          invoice_number = 'ЗВІТ-ДЕТАЛІЗАЦІЯ НАДАНИХ ПОСЛУГ №' + $scope.business.status.business_code + '-' +
              moment(period).endOf('month').format('YYYYMMDD') + '-д\nвід ' + moment(period).endOf('month').format('DD.MM.YYYY');

        if ($scope.legal_info.name_for_invoice) {
          legal_info += $scope.legal_info.name_for_invoice;
        } else {
          legal_info += $scope.legal_info.user_name;
        }

        if ($scope.legal_info.accounting_phone) {
          legal_info += '\n' + $scope.legal_info.accounting_phone;
        } else {
          legal_info += '\n' + $scope.legal_info.user_phone;
        }

        if ($scope.legal_info.accounting_email) {
          legal_info += '\n' + $scope.legal_info.accounting_email;
        } else {
          legal_info += '\n' + $scope.legal_info.user_email;
        }

        if ($scope.legal_info.legal_address)
          legal_info += '\nЮридичная адреса: ' + $scope.legal_info.legal_address;
        if ($scope.legal_info.post_address)
          legal_info += '\nДля листування: ' + $scope.legal_info.post_address;
        if ($scope.legal_info.accounting_phone)
          legal_info += '\nБухгалтерія: ' + $scope.legal_info.accounting_phone;
        if ($scope.legal_info.accounting_email)
          legal_info += ', ' + $scope.legal_info.accounting_email;
        var invoiceInfo, paymentInfo, signInfo;
        if ($scope.isIncust) {
          invoiceInfo = {
            text: 'ТОВ “СОФТПАНОРАМА ПЛЮС ПЛЮС”' + '\n' + 'Юридична адреса: Україна 02152, м.Київ, пр-т Тичини, 20\n' +
                'Для листування: 02081 м.Київ , вул.Урлівська, 11а, оф.69\n' +
                'Бухгалтерія: 38 044 394-95-94, uaacc@incust.com\n' +
                'Тел.: 38 044 394-95-94', style: 'text'
          };

          paymentInfo = {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Платіжні реквізити:',
                    style: 'text', bold: true
                  }],
                [
                  {
                    text: 'IBAN UA58 305299 00000 26000036224392 в АТ КБ "ПРИВАТБАНК"\n' +
                        'МФО 305299, ЄДРПОУ 32849350',
                    style: 'text'
                  }]
              ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 10]
          };
          signInfo = [
            {
              table: {
                widths: [150, '*'],
                body: [
                  [
                    {text: 'Виконавець:', style: 'text'},
                    {text: ' ', style: 'text'}],
                  [
                    {text: 'Підпис:', style: 'text'},
                    {text: '__________________________', style: 'text'}],
                  [
                    {text: 'М.П.', style: 'text'},
                    {text: 'Директор: Федченко В. О.', style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [150, '*'],
                body: [
                  [
                    {text: 'Замовник:', style: 'text'},
                    {text: ' ', style: 'text'}],
                  [
                    {text: 'Підпис:', style: 'text'},
                    {text: '__________________________', style: 'text'}],
                  [
                    {text: 'М.П.', style: 'text'},
                    {text: '', style: 'text'}]
                ]
              },
              layout: 'noBorders'
            },
            {
              image: $scope.img_seal,
              width: 90,
              margin: [150, -120, 0, 0]
            },
            {
              image: $scope.img_sign,
              width: 80,
              margin: [160, -70, 0, 0]
            }
          ];
        } else if ($scope.isPrimeFuel) {

          invoiceInfo = {
            text: 'Prime Fuels LLC' + '\n' + 'Юридична адреса: 280 50516 Range Road 233\n' +
                'Leduc County Alberta T4X0L4\n' +
                'prime-fuel.com\n' +
                'info@globalengmfg.com, Тел.: +61 (7) 31028365', style: 'text'
          };
          paymentInfo = {};
          signInfo = [];
        }
        var pdf_data = {
          pageSize: 'A4',
          pageMargins: [40, 40, 40, 20],
          content: [
            {
              image: $scope.img_logo,
              width: 80,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [invoice_number],
              style: 'header',
              alignment: 'center',
              margin: [0, 0, 0, 5]
            },
            {
              text: ['Дата друка ' + moment().format('DD.MM.YYYY') + ' р.' + moment().format('HH:mm')],
              style: 'text',
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              table: {
                widths: [130, '*'],
                body: [
                  [
                    {text: 'Особовий рахунок Замовника:', style: 'text'},
                    {text: $scope.business.status.business_code, style: 'text'}],

                  [
                    {text: 'Ref ID:', style: 'text'},
                    {text: $scope.business.referral_code, style: 'text'}],

                  [
                    {text: 'Представник Замовника:', style: 'text'},
                    {text: $scope.legal_info.customer_representative, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [300, '*'],
                body: [
                  [
                    invoiceInfo,
                    {text: legal_info, style: 'text'}]]

              },
              layout: 'noBorders',
              margin: [0, 0, 0, 20]
            },
            paymentInfo,
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Залишок коштів на початок періоду: ' + moment(td.period_begin_datetime).utc().format('DD.MM.YYYY') +
                          ' 00:00 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_begin_balance_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Надходження коштів на рахунок за період',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_refill_payment_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Надходження кредитних коштів на рахунок за період',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(period_refill_credit_payment_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Сума замовлених і наданих послуг за період',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_ordered_and_provided_services_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Надана знижка',
                      style: 'text'
                    },
                    {
                      text: $filter('number')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Залишок коштів на кінець періоду: ' + moment(td.period_end_datetime).utc().format('DD.MM.YYYY') + ' 23:59 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_end_balance_amount, 2) + ' грн.',
                      style: 'text', alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Деталізована інформація по надходженню коштів'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [100, 100],
                body: income_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Деталізована у часі інформація по замовленим і наданим послугам'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [100, 300, 100],
                body: operation_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            signInfo[0] ? signInfo[0] : [],
            signInfo[1] ? signInfo[1] : [],
            signInfo[2] ? signInfo[2] : [],
            signInfo[3] ? signInfo[3] : []

          ],
          defaultStyle: {
            font: 'calibri'
          },
          styles: {
            header: {
              bold: true,
              fontSize: 15
            },
            text: {
              fontSize: 9
            }
          }
        };

        $translate.use(current_language);
        callback(pdf_data);
      });
    }

    function prepareInvoiceDetailedRU(callback) {
      var current_language = $rootScope.LANG;

      $translate.use('ru').then(function() {
        var income_list = [
              [
                {text: 'Дата', style: 'text', bold: true},
                {text: 'Сумма, руб', style: 'text', bold: true, alignment: 'right'}]],
            income_amount = 0.00,
            operation_list = [
              [
                {text: 'Дата', style: 'text', bold: true},
                {text: 'Название услуги', style: 'text', bold: true},
                {text: 'Сумма, руб', style: 'text', bold: true, alignment: 'right'}]],
            operation_amount = 0.00,
            td = $scope.tariffDetails,
            billing = td.billing,
            period = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1),
            funds_income = td.period_refill_payment_amount - (td.period_discount_amount + td.period_business_bonuses_redeemed_amount),
            discount_result = td.period_discount_amount + td.period_business_bonuses_redeemed_amount,
            period_refill_credit_payment_amount = td.period_refill_credit_payment_amount,
            discount_result_string = $filter('number')(discount_result, 2),
            invoice_number = '',
            legal_info = '';

        if (!$scope.business.referral_code)
          $scope.business.referral_code = 'отсутствует';

        for (var i in billing) {
          if (billing[i].type == 'refill') {
            income_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {text: $filter('number')(billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            income_amount += billing[i].amount;
          } else if (billing[i].type == 'refill-cancel') {
            income_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {text: $filter('number')('-' + billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            income_amount -= billing[i].amount;

            operation_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {
                text: billing[i].public_title ? billing[i].public_title : $translate.instant($scope.getChargesTitle(billing[i].type)) || '',
                style: 'text'
              },
              {text: $filter('number')('-' + billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            operation_amount -= billing[i].amount;
          } else {
            operation_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {
                text: billing[i].public_title ? billing[i].public_title : $translate.instant($scope.getChargesTitle(billing[i].type)) || '',
                style: 'text'
              },
              {text: $filter('number')(billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            operation_amount += billing[i].amount;
          }
        }

        income_list.push([
          {text: 'Итого', bold: true, style: 'text'},
          {text: $filter('number')(income_amount, 2), style: 'text', bold: true, alignment: 'right'}]);
        operation_list.push([
          {
            text: 'Заказано и предоставлено услуг за период ' +
                $filter('date')(td.period_begin_datetime, 'dd.MM.yyyy') + ' 00:00 (UTC) - ' +
                $filter('date')(td.period_end_datetime, 'dd.MM.yyyy') + ' 23:59 UTC',
            style: 'text', bold: true, colSpan: 2
          },
          {text: ' '},
          {text: ' '}]);
        operation_list.push([
          {text: 'Итого (без НДС)', bold: true, style: 'text', colSpan: 2},
          {text: ' '},
          {text: $filter('number')(operation_amount, 2), style: 'text', bold: true, alignment: 'right'}]);

        if (($scope.staff.months.indexOf($scope.staff.month) + 1) == moment().format('M'))
          invoice_number = 'ОТЧЕТ-ДЕТАЛИЗАЦИЯ ОКАЗАННЫХ УСЛУГ №' + $scope.business.status.business_code + '-' +
              moment().format('YYYYMMDDHHmm') + '-д\nот ' + moment().format('DD.MM.YYYY');
        else
          invoice_number = 'ОТЧЕТ-ДЕТАЛИЗАЦИЯ ОКАЗАННЫХ УСЛУГ №' + $scope.business.status.business_code + '-' +
              moment(period).endOf('month').format('YYYYMMDD') + '-д\nот ' + moment(period).endOf('month').format('DD.MM.YYYY');

        if ($scope.legal_info.name_for_invoice) {
          legal_info += $scope.legal_info.name_for_invoice;
        } else {
          legal_info += $scope.legal_info.user_name;
        }

        if ($scope.legal_info.accounting_phone) {
          legal_info += '\n' + $scope.legal_info.accounting_phone;
        } else {
          legal_info += '\n' + $scope.legal_info.user_phone;
        }

        if ($scope.legal_info.accounting_email) {
          legal_info += '\n' + $scope.legal_info.accounting_email;
        } else {
          legal_info += '\n' + $scope.legal_info.user_email;
        }

        if ($scope.legal_info.legal_address)
          legal_info += '\nЮридический адрес: ' + $scope.legal_info.legal_address;
        if ($scope.legal_info.post_address)
          legal_info += '\nДля корреспонденции: ' + $scope.legal_info.post_address;
        if ($scope.legal_info.accounting_phone)
          legal_info += '\nБухгалтерия: ' + $scope.legal_info.accounting_phone;
        if ($scope.legal_info.accounting_email)
          legal_info += ', ' + $scope.legal_info.accounting_email;
        var invoiceInfo, paymentInfo, signInfo;
        if ($scope.isIncust) {
          invoiceInfo = {
            text: 'ООО “СОФТПАНОРАМА ПЛЮС ПЛЮС”' + '\n' + 'Юридический адрес: Украина 02152, г.Киев, пр-т Тычины, 20\n' +
                'Для корреспонденции: 02081 г.Киев , ул.Урловская, 11а, оф.69\n' +
                'Бухгалтерия: 38 044 220-15-15, uaacc@incust.com\n' +
                'Тел.: 38 044 394-95-94', style: 'text'
          },
              {text: legal_info, style: 'text'};

          paymentInfo = {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Платежные реквизиты:',
                    style: 'text', bold: true
                  }],
                [
                  {
                    text: 'Beneficiary: Softpanorama plus plus limited liability partnership\n' +
                        'Account #: UA573007110000026006052695978\n' +
                        'Beneficiary’s bank:  JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE\n' +
                        'SWIFT code :  PBANUA2X\n' +
                        'CORRESPONDENT BANKS: ОАО Белинвестбанк,Минск, Беларусь\n' +
                        'Account in the correspondent bank BY61BLBB17020009999920100001\n' +
                        'SWIFT Code of the correspondent bank BLBBBY2XXXX\n' +
                        'Сorrespondent′s bank аccount in the intermediary bank 30111810800000000154\n' +
                        'Intermediary bank ПАО СБЕРБАНК, Москва, Россия\n' +
                        'SWIFT, БИК, ІПН, КПП БАНКА-ПОСРЕДНИКА/IDENTIFICATION CODE OF THE INTERMEDIARY BANK\n' +
                        'SABRRUMM,044525225,7707083893,775001001\n' +
                        'НОМЕР РАХУНКУ БАНКА-ПОСЕРЕДНИКА В ГУ Банка Росії по ЦФО 30101810400000000225\n',
                    style: 'text'
                  }]
              ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 10]
          };
          signInfo = [
            {
              table: {
                widths: [150, '*'],
                body: [
                  [
                    {text: 'Исполнитель:', style: 'text'},
                    {text: ' ', style: 'text'}],
                  [
                    {text: 'Подпись:', style: 'text'},
                    {text: '__________________________', style: 'text'}],
                  [
                    {text: 'М.П.', style: 'text'},
                    {text: 'Директор: Федченко В. О.', style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [150, '*'],
                body: [
                  [
                    {text: 'Заказчик:', style: 'text'},
                    {text: ' ', style: 'text'}],
                  [
                    {text: 'Подпись:', style: 'text'},
                    {text: '__________________________', style: 'text'}],
                  [
                    {text: 'М.П.', style: 'text'},
                    {text: '', style: 'text'}]
                ]
              },
              layout: 'noBorders'
            }
          ];
        } else if ($scope.isPrimeFuel) {

          invoiceInfo = {
            text: 'Prime Fuels LLC' + '\n' + 'Юридический адрес: 280 50516 Range Road 233\n' +
                'Leduc County Alberta T4X0L4\n' +
                'prime-fuel.com\n' +
                'info@globalengmfg.com, Тел.: +61 (7) 31028365', style: 'text'
          };
          paymentInfo = {};
          signInfo = [];
        }
        var pdf_data = {
          pageSize: 'A4',
          pageMargins: [40, 40, 40, 20],
          content: [
            {
              image: $scope.img_logo,
              width: 80,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [invoice_number],
              style: 'header',
              alignment: 'center',
              margin: [0, 0, 0, 5]
            },
            {
              text: ['Дата печати ' + moment().format('DD.MM.YYYY') + ' г.' + moment().format('HH:mm')],
              style: 'text',
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              table: {
                widths: [130, '*'],
                body: [
                  [
                    {text: 'Личный счет Заказчика:', style: 'text'},
                    {text: $scope.business.status.business_code, style: 'text'}],

                  [
                    {text: 'Ref ID:', style: 'text'},
                    {text: $scope.business.referral_code, style: 'text'}],

                  [
                    {text: 'Представитель Заказчика:', style: 'text'},
                    {text: $scope.legal_info.customer_representative, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [300, '*'],
                body: [
                  [
                    invoiceInfo,
                    {text: legal_info, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            paymentInfo,
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Остаток средств на начало периода: ' + moment(td.period_begin_datetime).utc().format('DD.MM.YYYY') +
                          ' 00:00 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_begin_balance_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Поступление средств на счет за период',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_refill_payment_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Поступление кредитных средств на счет за период',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(period_refill_credit_payment_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Сумма заказанных и оказанных услуг за период',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_ordered_and_provided_services_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Предоставленная скидка',
                      style: 'text'
                    },
                    {
                      text: $filter('number')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Остаток средств на конец периода: ' + moment(td.period_end_datetime).utc().format('DD.MM.YYYY') + ' 23:59 UTC',
                      style: 'text'
                    },
                    {
                      text: $filter('number')(td.period_end_balance_amount, 2) + ' руб.',
                      style: 'text', alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Детализированная информация по поступлению средств'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [100, 100],
                body: income_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Детализированная по времени информация по заказанным и оказанным услугам'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [100, 300, 100],
                body: operation_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            signInfo[0] ? signInfo[0] : [],
            signInfo[1] ? signInfo[1] : []
          ],
          defaultStyle: {
            font: 'calibri'
          },
          styles: {
            header: {
              bold: true,
              fontSize: 15
            },
            text: {
              fontSize: 8
            }
          }
        };

        $translate.use(current_language);
        callback(pdf_data);
      });
    }

    function prepareInvoiceDetailedEN(callback) {
      var current_language = $rootScope.LANG;

      $translate.use('en').then(function() {
        var td = $scope.tariffDetails,
            currency = $scope.tariffDetails.billing.length > 0 ? $scope.tariffDetails.billing[0].currency : ' ',
            income_list = [
              [
                {text: 'Date', style: 'text', bold: true},
                {text: 'Amount, ' + $filter('currencyFormat')(null, currency), style: 'text', bold: true, alignment: 'right'}]],
            income_amount = 0.00,
            operation_list = [
              [
                {text: 'Date', style: 'text', bold: true},
                {text: 'Name', style: 'text', bold: true},
                {text: 'Amount, ' + $filter('currencyFormat')(null, currency), style: 'text', bold: true, alignment: 'right'}]],
            operation_amount = 0.00,

            billing = td.billing,
            period = '{0}-{1}-01'.format($scope.staff.year, $scope.staff.months.indexOf($scope.staff.month) + 1),
            funds_income = td.period_refill_payment_amount - (td.period_discount_amount + td.period_business_bonuses_redeemed_amount),
            discount_result = td.period_discount_amount + td.period_business_bonuses_redeemed_amount,
            period_refill_credit_payment_amount = td.period_refill_credit_payment_amount,
            discount_result_string = $filter('number')(discount_result, 2),
            invoice_number = '',
            legal_info = '';

        if (!$scope.business.referral_code)
          $scope.business.referral_code = '-';

        for (var i in billing) {
          if (billing[i].type == 'refill') {
            income_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {text: $filter('number')(billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            income_amount += billing[i].amount;
          } else if (billing[i].type == 'refill-cancel') {
            income_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {text: $filter('number')('-' + billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            income_amount -= billing[i].amount;

            operation_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {
                text: billing[i].public_title ? billing[i].public_title : $translate.instant($scope.getChargesTitle(billing[i].type)) || '',
                style: 'text'
              },
              {text: $filter('number')('-' + billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            operation_amount -= billing[i].amount;
          } else {
            operation_list.push([
              {text: $filter('date')(billing[i].processed, 'yyyy.MM.dd HH:mm'), style: 'text'},
              {
                text: billing[i].public_title ? billing[i].public_title : $translate.instant($scope.getChargesTitle(billing[i].type)) || '',
                style: 'text'
              },
              {text: $filter('number')(billing[i].amount, 2), style: 'text', alignment: 'right'}]);
            operation_amount += billing[i].amount;
          }
        }

        income_list.push([
          {text: 'Total', bold: true, style: 'text'},
          {text: $filter('number')(income_amount, 2), style: 'text', bold: true, alignment: 'right'}]);
        operation_list.push([
          {
            text: 'Billing Cycle: ' +
                $filter('date')(td.period_begin_datetime, 'dd.MM.yyyy') + ' 00:00 (UTC) - ' +
                $filter('date')(td.period_end_datetime, 'dd.MM.yyyy') + ' 23:59 UTC',
            style: 'text', bold: true, colSpan: 2
          },
          {text: ' '},
          {text: ' '}]);
        operation_list.push([
          {text: 'Total', bold: true, style: 'text', colSpan: 2},
          {text: ' '},
          {text: $filter('number')(operation_amount, 2), style: 'text', bold: true, alignment: 'right'}]);

        if (($scope.staff.months.indexOf($scope.staff.month) + 1) == moment().format('M'))
          invoice_number = 'SERVICE REPORT #' + $scope.business.status.business_code + '-' + moment().format('YYYYMMDDHHmm') + ', ' +
              moment().format('MM.DD.YYYY');
        else
          invoice_number = 'SERVICE REPORT #' + $scope.business.status.business_code + '-' +
              moment(period).endOf('month').format('YYYYMMDD') + ', ' + moment(period).endOf('month').format('MM.DD.YYYY');

        if ($scope.legal_info.name_for_invoice) {
          legal_info += $scope.legal_info.name_for_invoice;
        } else {
          legal_info += $scope.legal_info.user_name;
        }

        if ($scope.legal_info.accounting_phone) {
          legal_info += '\n' + $scope.legal_info.accounting_phone;
        } else {
          legal_info += '\n' + $scope.legal_info.user_phone;
        }

        if ($scope.legal_info.accounting_email) {
          legal_info += '\n' + $scope.legal_info.accounting_email;
        } else {
          legal_info += '\n' + $scope.legal_info.user_email;
        }

        if ($scope.legal_info.legal_address)
          legal_info += '\nLegal address: ' + $scope.legal_info.legal_address;
        if ($scope.legal_info.post_address)
          legal_info += '\nMailing address: ' + $scope.legal_info.post_address;
        if ($scope.legal_info.accounting_phone)
          legal_info += '\nAccounting department: ' + $scope.legal_info.accounting_phone;
        if ($scope.legal_info.accounting_email)
          legal_info += ', ' + $scope.legal_info.accounting_email;
        var invoiceInfo;
        if ($scope.isIncust) {
          invoiceInfo = {
            text: 'inCust Ltd.' + '\n' + '20-22 Wenlock Road\n' +
                'London, N1 7GU, UK\n' +
                'incust.com\n' +
                'mailto:info@incust.com, +44 800 060 8 424', style: 'text'
          };
        } else if ($scope.isPrimeFuel) {
          invoiceInfo = {
            text: 'Prime Fuels LLC' + '\n' + '280 50516 Range Road 233\n' +
                'Leduc County Alberta T4X0L4\n' +
                'prime-fuel.com\n' +
                'mailto:info@globalengmfg.com, +61 (7) 31028365', style: 'text'
          };
        }
        var pdf_data = {
          pageSize: 'A4',
          pageMargins: [40, 40, 40, 20],
          content: [
            {
              image: $scope.img_logo,
              width: 80,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [invoice_number],
              style: 'header',
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text: [
                'Billing Cycle: ' +
                moment(td.period_begin_datetime).utc().format('MM.DD.YYYY') +
                ' - ' +
                moment(td.period_end_datetime).utc().format('MM.DD.YYYY') +
                '. Printed: ' +
                moment().format('MM.DD.YYYY') +
                ' ' +
                moment().format('HH:mm')
              ],
              style: 'text',
              alignment: 'center',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [130, '*'],
                body: [
                  [
                    {text: 'Account ID:', style: 'text'},
                    {text: $scope.business.status.business_code, style: 'text'}],

                  [
                    {text: 'Ref ID:', style: 'text'},
                    {text: $scope.business.referral_code, style: 'text'}],

                  [
                    {text: 'Account Owner Details:', style: 'text'},
                    {text: $scope.legal_info.customer_representative, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [300, '*'],
                body: [
                  [
                    invoiceInfo,
                    {text: legal_info, style: 'text'}]
                ]
              },
              layout: 'noBorders',
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [280, 100],
                body: [
                  [
                    {
                      text: 'Previous balance: ' + moment(td.period_begin_datetime).utc().format('MM.DD.YYYY') + ' 00:00 UTC',
                      style: 'text'
                    },
                    {
                      //  text: currency + ' ' + $filter('number')(td.period_begin_balance_amount, 2),
                      text: $filter('currencyFormat')(td.period_begin_balance_amount, currency),
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Payments received during the period',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_refill_payment_amount, 2),
                      text: $filter('currencyFormat')(td.period_refill_payment_amount, currency),
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Receipt of credit funds to the account for the period',
                      style: 'text'
                    },
                    {
                      // text: '$ ' + $filter('number')(period_refill_credit_payment_amount, 2),
                      text: $filter('currencyFormat')(period_refill_credit_payment_amount, currency),
                      style: 'text', alignment: 'right'
                    }
                  ],

                  [
                    {
                      text: 'Services provided during the period',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_ordered_and_provided_services_amount, 2),
                      text: $filter('currencyFormat')(td.period_ordered_and_provided_services_amount, currency),
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Discount',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), 2),
                      text: $filter('currencyFormat')((td.period_discount_amount + td.period_business_bonuses_redeemed_amount), currency),
                      style: 'text', alignment: 'right'
                    }],

                  [
                    {
                      text: 'Outstanding balance: ' + moment(td.period_end_datetime).utc().format('MM.DD.YYYY') + ' 23:59 UTC',
                      style: 'text'
                    },
                    {
                      // text: currency + ' ' + $filter('number')(td.period_end_balance_amount, 2),
                      text: $filter('currencyFormat')(td.period_end_balance_amount, currency),
                      style: 'text', alignment: 'right'
                    }]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: [' Payments received during the period '],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [100, 100],
                body: income_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            },
            {
              text: ['Detailed information on ordered and provided services'],
              style: 'text',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              table: {
                widths: [100, 300, 100],
                body: operation_list
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0.2;
                },
                vLineWidth: function(i, node) {
                  return 0.2;
                }
              },
              margin: [0, 0, 0, 20]
            }
          ],
          defaultStyle: {
            font: 'calibri'
          },
          styles: {
            header: {
              bold: true,
              fontSize: 15
            },
            text: {
              fontSize: 8
            }
          }
        };

        $translate.use(current_language);
        callback(pdf_data);
      });
    }

    $scope.popupUpgradePlan = function() {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: true,
        templateUrl: 'app/templates/modal.tariff-change.html',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;
          popup.tariffList = [];
          var block_form_tariff_change = blockUI.instances.get('form-tariff-change');

          getAvailableTariffs();

          function getAvailableTariffs() {
            block_form_tariff_change.start();
            BusinessService.GetAvailableTariffs({tariff_type: 'downgrade'}, function(success, data) {
              if (success) {
                data.forEach(function(tariff) {
                  tariff.isDowngrade = true;
                });
                popup.tariffList = angular.copy(data);

                BusinessService.GetAvailableTariffs({tariff_type: 'upgrade'}, function(success, data) {
                  if (success) {
                    popup.tariffList = popup.tariffList.concat(data);
                  }
                  block_form_tariff_change.stop();
                });
              }
              block_form_tariff_change.stop();
            });
          }

          popup.saveTariff = function(form) {
            if (form.tariff.$valid) {
              var params = {
                id: popup.tariff.id
              };

              block_form_tariff_change.start();
              BusinessService.SetTariff(params, function(success, response) {
                if (success) {
                  $scope.tariff = response.tariff;
                  NotifyService.Success('', false);
                }
                block_form_tariff_change.stop();
                popup.closeModal();
              });
            } else {
              form.tariff.$dirty = true;
            }
          };

          popup.openSupportMessageModal = function() {
            $uibModalInstance.close();
            var name = $rootScope.USER.name ? $rootScope.USER.name + ', ' : '',
                login = $rootScope.USER.login ? $rootScope.USER.login + '\n' : '',
                msg = name +
                    login +
                    $filter('translate')('TEXT_TARIFF_REQUEST_MESSAGE', {entity: popup.tariff.description});

            $rootScope.onSendMessageToIncust(msg);
          };

          popup.closeModal = function() {
            $uibModalInstance.close();
          };
        }
      });
    };
    $rootScope.$watch('[COUNTRIES[LANG]]', function(newValue, oldValue, scope) {
      if (newValue) {
        if ($rootScope.COUNTRIES)
          $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[$rootScope.LANG]);
      }
    }, true);

    $scope.$watch('staff.country', function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        switch ($scope._pageMode) {
          case 'sms-details':
            showSMSTariff();
            break;
          case 'viber-details':
            showViberTariff();
            break;
        }

      }
    });
    $scope.$on('$locationChangeStart', function() {
      $uibModalStack.dismissAll();
    });

  }
})();
